const React = require('react');
const map = require('mn-utils/map');
const upperFirst = require('mn-utils/upperFirst');
const Tooltip = require('../../../../dumb/Tooltip/B');

const DataBlock = require('./DataBlock');

module.exports = (props) => {
  const data = props.data || {};

  const status = data.state;

  const dataArr = [
    {
      title: 'User',
      value: data.customer_email
        ? (
          <Tooltip className="fhaS">
            {data.customer_email}
          </Tooltip>
        ) : '-',
    },
    {
      title: 'External User ID',
      value: data.customer_external_id
        ? (
          <Tooltip className="fhaS">
            {data.customer_external_id}
          </Tooltip>
        ) : '-',
    },
    {
      title: 'External TRX ID',
      value: data.merchant_trx_id
        ? (
          <Tooltip className="fhaS">
            {data.merchant_trx_id}
          </Tooltip>
        ) : '-',
    },
    {
      title: 'Status',
      value: (
        <span
          className={`cFFBF43.created cFFBF43.confirmed c2CE889.completed
                c9C8FFF.requested c717275.expired cEE4F4F.cancelled cEE4F4F.failed fw7 ${status}`}
        >
          {upperFirst(status || '')}
        </span>
      ),
    },
  ];

  return (
    <div className="layoutRow fxwWrap mh-25 mt10">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/4 w1/2@m w@m2 mt25 ph25">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
